import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardOperatingOrderInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardOperatingOrderInterfaceUX-div-0"
        style={{width: "calc(-150px + 100vw)", height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardOperatingOrderInterfaceUX-div-1"
          style={{padding: "10px 10px 15px", marginBottom: "-10px"}}>
          
          <FormGroup
            id="CardOperatingOrderInterfaceUX-FormGroup-4">
            <FormField
              className="noPadding --hard"
              id="CardOperatingOrderInterfaceUX-FormField-11">
              <label
                id="CardOperatingOrderInterfaceUX-label-16">
                {props.languageUX === "en" ? "HN" : "HN"}
              </label>
              <Input
                id="CardOperatingOrderInterfaceUX-Input-21"
                name="hn"
                onChange={props.onChangeData}
                value={props.searchOperatingOrder?.hn || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardOperatingOrderInterfaceUX-FormField-12"
              style={{marginLeft: "20px"}}>
              <label
                id="CardOperatingOrderInterfaceUX-label-17">
                {props.languageUX === "en" ? "Encounter Number" : "Encounter Number"}
              </label>
              <Input
                id="CardOperatingOrderInterfaceUX-Input-22"
                name="encounterNumber"
                onChange={props.onChangeData}
                value={props.searchOperatingOrder?.encounterNumber || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardOperatingOrderInterfaceUX-FormField-13"
              style={{marginLeft: "20px"}}>
              <label
                id="CardOperatingOrderInterfaceUX-label-18">
                {props.languageUX === "en" ? "Code" : "รหัส"}
              </label>
              <Input
                id="CardOperatingOrderInterfaceUX-Input-23"
                name="code"
                onChange={props.onChangeData}
                value={props.searchOperatingOrder?.code || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardOperatingOrderInterfaceUX-FormField-14"
              style={{marginLeft: "20px"}}>
              <label
                id="CardOperatingOrderInterfaceUX-label-19">
                {"\u00A0"}
              </label>
              <div
                id="CardOperatingOrderInterfaceUX-div-24">
                {props.searchButton}
              </div>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardOperatingOrderInterfaceUX-FormField-15"
              style={{marginLeft: "20px"}}>
              <label
                id="CardOperatingOrderInterfaceUX-label-20">
                {"\u00A0"}
              </label>
              <Button
                color="orange"
                id="CardOperatingOrderInterfaceUX-Button-25"
                onClick={props.onClearFilter}>
                {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
              </Button>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardOperatingOrderInterfaceUX-div-2">
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.operatingOrderInterfaceList}
            id="CardOperatingOrderInterfaceUX-Table-6"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardOperatingOrderInterfaceUX-div-3"
          style={{ marginTop: "20px" }}>
          
          <FormGroup
            id="CardOperatingOrderInterfaceUX-FormGroup-5"
            inline={true}
            style={{ display: "flex", justifyContent: "flex-end" }}>
            <FormField
              id="CardOperatingOrderInterfaceUX-FormField-7">
              <div
                id="CardOperatingOrderInterfaceUX-div-9">
                {props.triggerButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardOperatingOrderInterfaceUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"calc(-150px + 100vw)\", height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormGroup-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 6,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.operatingOrderInterfaceList"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-Table-6"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormField-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.triggerButton"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-div-9"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormField-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormField-12"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormField-13"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormField-14"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-FormField-15"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "HN",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter Number",
          "valueEN": "Encounter Number"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส",
          "valueEN": "Code"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-label-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-label-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-label-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Input",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-Input-21"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchOperatingOrder?.hn || \"\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Input",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-Input-22"
        },
        "name": {
          "type": "value",
          "value": "encounterNumber"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchOperatingOrder?.encounterNumber || \"\""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Input",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-Input-23"
        },
        "name": {
          "type": "value",
          "value": "code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchOperatingOrder?.code || \"\""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardOperatingOrderInterfaceUX-Button-25"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 25,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardOperatingOrderInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
